var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLeaved
    ? _c(
        "div",
        { staticClass: "my-setting-modal-cover", on: { click: _vm.onClose } },
        [
          _c(
            "div",
            {
              staticClass: "my-setting-container",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "my-setting-header-container" }, [
                !_vm.isOpenDepsModal
                  ? _c("button", {
                      staticClass: "close-modal",
                      on: { click: _vm.onClose },
                    })
                  : _c("button", {
                      staticClass: "back-feature",
                      on: { click: _vm.onCloseDepsModal },
                    }),
                !_vm.isOpenDepsModal
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.$t("camstudy.mySetting.title"))),
                    ])
                  : _c("div", [_vm._v(_vm._s(_vm.modalTitle))]),
                _c("div", { staticClass: "my-setting-icon" }),
              ]),
              !_vm.isOpenDepsModal
                ? _c("div", { staticClass: "my-setting-body-container" }, [
                    _c("ul", { staticClass: "my-setting-inner-container" }, [
                      _vm.isOpenFixedScreen
                        ? _c("li", { staticClass: "my-setting-item" }, [
                            _c(
                              "div",
                              { staticClass: "my-setting-item-content" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "my-setting-item-paragraph" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("camstudy.mySetting.fixMyScreen")
                                      )
                                    ),
                                  ]
                                ),
                                _c("GrmToggle", {
                                  attrs: { "is-checked": _vm.fixedScreen },
                                  on: {
                                    "update:isChecked": function ($event) {
                                      _vm.fixedScreen = $event
                                    },
                                    "update:is-checked": function ($event) {
                                      _vm.fixedScreen = $event
                                    },
                                    onChange: _vm.changeStatus,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "my-setting-item-description" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("camstudy.mySetting.fixMyScreenDesc")
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm.isOpenAutoBrightness
                        ? _c("li", { staticClass: "my-setting-item" }, [
                            _c(
                              "div",
                              { staticClass: "my-setting-item-content" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "my-setting-item-paragraph" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "camstudy.mySetting.autoBrightness"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("GrmToggle", {
                                  attrs: { "is-checked": _vm.autoBrightness },
                                  on: {
                                    "update:isChecked": function ($event) {
                                      _vm.autoBrightness = $event
                                    },
                                    "update:is-checked": function ($event) {
                                      _vm.autoBrightness = $event
                                    },
                                    onChange: _vm.changeStatus,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "my-setting-item-description" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "camstudy.mySetting.autoBrightnessDesc"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _c("li", { staticClass: "my-setting-item" }, [
                        _c("div", { staticClass: "my-setting-item-content" }, [
                          _c(
                            "p",
                            { staticClass: "my-setting-item-paragraph" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "camstudy.mySetting.autoBrightnessTimeSetting"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "select-container" },
                            [
                              _c("GrmCamstudySelect", {
                                attrs: {
                                  title: _vm.$t(
                                    "camstudy.mySetting.timeSetting"
                                  ),
                                  value: _vm.autoBrightnessTerm,
                                  list: _vm.brightnessTimeOptions,
                                  name: "bright-time",
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.autoBrightnessTerm = $event
                                  },
                                  onChange: _vm.changeStatus,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "my-setting-item-description" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "camstudy.mySetting.autoBrightnessTimeDesc"
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "li",
                        {
                          staticClass: "my-setting-item",
                          on: { click: _vm.onOpenTestFeature },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "my-setting-item-content" },
                            [
                              _c(
                                "p",
                                { staticClass: "my-setting-item-paragraph" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("camstudy.mySetting.laboratory")
                                    )
                                  ),
                                ]
                              ),
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "my-setting-item-description" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("camstudy.mySetting.laboratoryDesc")
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          staticClass: "my-setting-item",
                          on: { click: _vm.onOpenLanguageModal },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "my-setting-item-content" },
                            [
                              _c(
                                "p",
                                { staticClass: "my-setting-item-paragraph" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "camstudy.mySetting.language.title"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._m(0),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm.modalType === "test-feature"
                ? _c("div", { staticClass: "my-setting-body-container" }, [
                    _c("div", { staticClass: "test-feature-container" }, [
                      _c("img", {
                        staticClass: "test-feature-image",
                        attrs: {
                          src: require("@/assets/images/camstudy/test_feature_image.svg"),
                        },
                      }),
                      _c("div", [
                        _c("div", { staticClass: "test-feature-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("camstudy.mySetting.testFeatureTitle")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "test-feature-message" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("camstudy.mySetting.testFeatureMessage")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c("ul", { staticClass: "my-setting-inner-container" }),
                  ])
                : _vm.modalType === "language-setting"
                ? _c("div", { staticClass: "my-setting-body-container" }, [
                    _c(
                      "ul",
                      { staticClass: "my-setting-inner-container" },
                      _vm._l(_vm.sortedLanguages, function (lang) {
                        return _c(
                          "li",
                          { key: lang.value, staticClass: "my-setting-item" },
                          [
                            _c(
                              "label",
                              { on: { click: _vm.onChangedOption } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "my-setting-item-content" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "my-setting-item-paragraph",
                                      },
                                      [_vm._v(_vm._s(lang.name))]
                                    ),
                                    _c("input", {
                                      attrs: {
                                        type: "radio",
                                        name: "language-radio",
                                      },
                                      domProps: {
                                        value: lang.value,
                                        checked:
                                          _vm.selectedValue === lang.value,
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }